/**
 * NextLayerStudio - QR-Code Personalisierung (Block)
 * Rendert eine Live-QR-Vorschau ueber die vendored qrcode-generator Lib.
 * Pflichtfeld-Validierung uebernimmt der Browser selbst (input nutzt
 * das form="..."-Attribut, das an das echte Produktformular bindet).
 */
(function () {
  "use strict";

  var QR_DEBOUNCE_MS = 250;

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var args = arguments;
      var ctx = this;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function renderQrPreview(block) {
    var input = block.querySelector("[data-nls-qr-input]");
    var preview = block.querySelector("[data-nls-qr-preview]");
    var canvas = block.querySelector("[data-nls-qr-canvas]");
    var tooLong = block.querySelector("[data-nls-qr-toolong]");
    if (!input || !preview || !canvas) return;

    var value = input.value.trim();

    if (!value) {
      preview.hidden = true;
      if (tooLong) tooLong.hidden = true;
      canvas.innerHTML = "";
      return;
    }

    if (typeof window.qrcode !== "function") return;

    try {
      var qr = window.qrcode(0, "M");
      qr.addData(value);
      qr.make();
      canvas.innerHTML = qr.createSvgTag({ scalable: true });
      preview.hidden = false;
      if (tooLong) tooLong.hidden = true;
    } catch (err) {
      preview.hidden = true;
      canvas.innerHTML = "";
      if (tooLong) tooLong.hidden = false;
    }
  }

  function initBlock(block) {
    if (block.dataset.nlsInit === "true") return;
    block.dataset.nlsInit = "true";

    var input = block.querySelector("[data-nls-qr-input]");
    if (!input) return;

    var debouncedRender = debounce(function () {
      renderQrPreview(block);
    }, QR_DEBOUNCE_MS);

    input.addEventListener("input", debouncedRender);
    renderQrPreview(block);
  }

  function init(root) {
    (root || document).querySelectorAll("[data-nls-qr-block]").forEach(initBlock);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
